import React from 'react'
import loadable from '@loadable/component'
const MathIconSVG = loadable(() => import(/*webpackChunkName: 'icons'*/"./MathIconsSVG"))

class MathIcon extends React.Component{
  render(){
    return(
      <MathIconSVG name={this.props.name} />        
    )
  }
}

export default MathIcon
